import { ArrowRight, BadgeCheck } from "lucide-react";
import { toast } from "sonner";
import SectionHeading, { Reveal } from "@/components/SectionHeading";
import { PRICING } from "@/data/content";

export default function Membership({ onEnquire }) {
  return (
    <section id="membership" data-testid="membership-section" className="bg-[#0A0A0A] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Membership"
          title="Choose Your"
          accent="Fitness Journey"
          subtext="Simple, honest pricing at both open branches. Pick your chapter and start training."
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
          {PRICING.map((p, i) => (
            <Reveal key={p.branchId} delay={i * 0.1} className="h-full">
              <article
                data-testid={`membership-card-${p.branchId}`}
                className="h-full flex flex-col bg-[#141414] border border-white/10 rounded-xl p-7 transition-all duration-300 hover:border-[#FF5A1F]/60 hover:shadow-[0_16px_40px_rgba(255,90,31,0.15)] hover:-translate-y-1.5"
              >
                <h3 className="font-heading text-2xl tracking-wider text-white uppercase">
                  {p.branchName}
                </h3>
                <p className="mt-1 text-xs uppercase tracking-[0.2em] font-semibold text-[#FF5A1F]">
                  {p.area}
                </p>
                <ul className="mt-6 flex-1 divide-y divide-white/10">
                  {p.rows.map((r) => (
                    <li
                      key={r.label}
                      data-testid={`membership-price-${p.branchId}-${r.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="flex items-center justify-between gap-4 py-3.5"
                    >
                      <span className="text-sm text-[#D1D1D1]">{r.label}</span>
                      {r.price ? (
                        <span className="font-heading text-2xl tracking-wide text-[#FF5A1F]">
                          {r.price}
                        </span>
                      ) : (
                        <span className="text-xs uppercase tracking-widest text-[#8E8E93]">
                          Not available
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`membership-details-${p.branchId}-button`}
                  onClick={() => onEnquire(p.branchId)}
                  className="mt-7 w-full inline-flex items-center justify-center gap-2 bg-[#FF5A1F] hover:bg-[#E0480F] text-white font-heading text-lg tracking-widest px-6 py-3 rounded-sm transition-colors"
                >
                  GET MEMBERSHIP DETAILS <ArrowRight className="w-4 h-4" />
                </button>
              </article>
            </Reveal>
          ))}
          <Reveal delay={0.2} className="h-full">
            <article
              data-testid="membership-card-chapter-3"
              className="h-full flex flex-col bg-[#141414] border border-dashed border-[#FF5A1F]/50 rounded-xl p-7"
            >
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <h3 className="font-heading text-2xl tracking-wider text-white uppercase">
                  F12 FITNESS CHAPTER 3
                </h3>
                <span className="bg-[#FF5A1F]/20 text-[#FF5A1F] border border-[#FF5A1F]/60 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest animate-pulse">
                  Opening Soon
                </span>
              </div>
              <p className="mt-6 text-sm leading-relaxed text-[#D1D1D1] flex-1">
                Membership prices and opening hours for Chapter 3 will be announced soon. Stay
                tuned for our grand opening.
              </p>
              <button
                data-testid="membership-stay-tuned-button"
                onClick={() => toast.info("Chapter 3 membership details coming soon — stay tuned!")}
                className="mt-7 w-full inline-flex items-center justify-center gap-2 border-2 border-[#FF5A1F] text-[#FF5A1F] hover:bg-[#FF5A1F] hover:text-white font-heading text-lg tracking-widest px-6 py-3 rounded-sm transition-colors"
              >
                <BadgeCheck className="w-4 h-4" /> STAY TUNED
              </button>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
